import React from 'react';
import PropTypes from 'prop-types';

import {Grid} from 'views/components';

import SecureFileGridItem from './SecureFileGridItem';

const SecureFileGrid = (props) => {
  const files = props.files;
  const sx = props.sx;
  const menuItems = props.menuItems;

  return (
    <Grid container spacing={2} sx={sx}>
      {
        files.map((file) =>
          <SecureFileGridItem
            key={file.src}
            file={file}
            menuItems={menuItems?.filter((item) => {
              if (item.condition) {
                return item.condition(file);
              } else {
                return true;
              }
            })}
          />,
        )
      }
    </Grid>
  );
};

SecureFileGrid.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  })).isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    handler: PropTypes.func.isRequired,
    Icon: PropTypes.elementType,
    condition: PropTypes.func, // a function accepting the file and returning true or false depending on if it should be displayed
  })),
  sx: PropTypes.object,
};

export default SecureFileGrid;
